import React, { Component } from 'react'

class PayInstitution extends Component {
    render() {
        return (
            <div>
                
            </div>
        )
    }
}

export default PayInstitution

